import sanityClient from "@sanity/client";

export default sanityClient({
    projectId: "343pp4ll",
    dataset: "production",
    useCdn: true,
    apiVersion: "v2021-06-07"
});
